import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { Alert } from '@app/_models';
import { Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class AlertService {
    alertas: Alert[];
    constructor(private http: HttpClient,) 
    {
        this.alertas = [];
     }
    
    getAll() {

        return this.http.get<any>(`${environment.apiUrl}/MessageWeb/Get`);

        
        
       /* for( let i = 0; i<2; i++){
            let aux = new Alert();
            aux.messageWebID = i;
            aux.messageWebTitle = "Hola, mensaje desde la clínica: "+i;
            aux.messageWebDescription = "Pasa a leer el mensaje recibido desde la clínica "+i;
            aux.fullPath = "assets/img-web/news/anuncio-3.png"
           this.alertas.push(aux)
        }
        
        return this.alertas;*/
    }



}
